import React, { Component, PropTypes } from 'react';
import {
  StyledEstimatorTitleWrapper,
  StyledEstimatorTitle,
  StyledEstimatorByline
} from './styles';

class TitlePanel extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string
  }
  static defaultProps = {
    description: undefined
  }
  static renderDescription(description) {
    return (description) ? (
      <StyledEstimatorByline>{description}</StyledEstimatorByline>
    ) : undefined;
  }
  constructor() {
    super();
    this.renderDescription = TitlePanel.renderDescription.bind(this);
  }
  render() {
    const { title, description } = this.props;
    return (
      <StyledEstimatorTitleWrapper className="row payment-estimator-title margin-bottom-small">
        <StyledEstimatorTitle className="heading-first">{ title }</StyledEstimatorTitle>
        {this.renderDescription(description)}
      </StyledEstimatorTitleWrapper>
    );
  }
}

export default TitlePanel;



/** WEBPACK FOOTER **
 ** ./src/components/Title/index.js
 **/